// Developer URL overrides kept in localStorage (ADR 0006, ADR 0017).
// These keys are SHARED with the portal and are only ever read here, never
// written. Every read is wrapped: storage can be unavailable (private mode,
// blocked site data) and then the build-time value applies.

export const API_URL_KEY = 'oaseApiUrl'
export const EWS_AUTH_URL_KEY = 'EWS_AUTH_URL'
export const EWS_GET_FOLDERS_API_KEY = 'EWS_GET_FOLDERS_API'

/** A stored override, or null when absent, empty or unreadable. */
export function readOverride(key: string): string | null {
  try {
    const value = localStorage.getItem(key)
    return value || null
  } catch {
    return null
  }
}

/**
 * The OASE API base: `localStorage.oaseApiUrl ?? APP_OAP_API_URL`, resolved on
 * every call so an override applies without a rebuild. Throws the portal's
 * `getOaseApiUrl` message when neither is set (portal: src/utils/getOaseApiUrl.ts).
 */
export function apiBaseUrl(): string {
  const url = readOverride(API_URL_KEY) ?? import.meta.env.APP_OAP_API_URL
  if (!url) {
    throw new Error(
      'OASE API URL is not configured (set APP_OAP_API_URL or the "oaseApiUrl" override).'
    )
  }
  return url
}

/** EWS / Graph auth URL: `localStorage.EWS_AUTH_URL ?? fallback` (portal: EwsForm.tsx:26, GraphFormV2–4). */
export function ewsAuthUrl(fallback: string | undefined): string | undefined {
  return readOverride(EWS_AUTH_URL_KEY) ?? fallback
}

/** EWS / Graph folders API: `localStorage.EWS_GET_FOLDERS_API || fallback` (portal: useFetchGraphFolders.ts:30, EwsForm.tsx:91). */
export function ewsFoldersApi(fallback: string | undefined): string | undefined {
  return readOverride(EWS_GET_FOLDERS_API_KEY) ?? fallback
}
